const data = [
  {
    name: "Naidu Setti",
    company: "ERP Force",
    status: "Paid",
    email: "naidu@gmail.com",
    amount: "$1,00,000",
  },
  {
    name: "Shashank Yadav",
    company: "Antino Labs",
    status: "Pending",
    email: "shashank@gmail.com",
    amount: "$50,000",
  },
  {
    name: "Tarun Prajapati",
    company: "Goldenflitch",
    status: "Lost",
    email: "tarun@gmail.com",
    amount: "$60,000",
  },
  {
    name: "Rajneesh Kumar",
    company: "ERP Force",
    status: "Lost",
    email: "rajneesh@gmail.com",
    amount: "$10,000",
  },
  {
    name: "Radhakanth",
    company: "Antino",
    status: "Upcomming",
    email: "radhakanth@gmail.com",
    amount: "$1,00,000",
  },
];

export { data };
export default data;
